<script lang="ts" setup>
import { ClovyrCodeLogo } from '@clovyr/bed';
import SimbaBlocksLogo from '@clovyr/bed/assets/images/simbachain-logo.svg';

import InstantCode from './InstantCode.vue';

defineProps<{ instantLaunchApp: string }>();
</script>
<template>
  <InstantCode
    :instant-launch-app="instantLaunchApp"
    hide-code-desc
    head-title="SIMBAChain"
    :head-logo="SimbaBlocksLogo"
  >
    <div class="logo">
      <ImageMedia class="invert" :filename="SimbaBlocksLogo" />
      <div class="plus">&nbsp;&nbsp;+&nbsp;&nbsp;</div>
      <ClovyrCodeLogo />
    </div>
    <p>
      SIMBAChain + Clovyr Code is a complete, one-click developer environment, so you can start
      building now.
    </p>
  </InstantCode>
</template>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
:deep(div.invert) img {
  filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(10deg) brightness(104%) contrast(101%);
}
</style>
